import $ from 'jquery';

const defaults = {
  selector: '.node-inner',
  linkLocation: '.link-read-more a',
};

function ProgramsRedirect(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.wrap();
}

ProgramsRedirect.prototype = {
  wrap() {
    const $wrapper = this.$element.find(this.settings.selector);
    const content = $wrapper.contents();
    const url = $wrapper.find(this.settings.linkLocation).attr('href');
    $wrapper.prepend(`<a href="${url}" class="home-programs-custom-links" tabindex="-1"></a>`);
    $wrapper.children().first().prepend(content);
  },
};

export default ProgramsRedirect;
